/**
 * Which deployment this page is (step 96, the user, 2026-10-29: "a mark on the whole app for dev and
 * staging — in production nothing"; and a share from staging must say so, "so I don't send shares from
 * the wrong environment by mistake").
 *
 * Decided at BUILD time, never from the address (hard rule 2 — the domain is configuration): the dev
 * server is dev; the staging build sets `VITE_DEPLOY_ENV=staging` (`.github/workflows/deploy-staging.yml`);
 * any other build is production — so a production bundle carries no mark, whatever happens to its env.
 */
export type DeployEnv = 'dev' | 'staging' | 'production';

export function deployEnv(): DeployEnv {
  const named = import.meta.env.VITE_DEPLOY_ENV as string | undefined;
  if (named === 'staging' || named === 'dev') return named;
  // A test run is no deployment: it draws no ribbon and shares the words as they are (a test names its env).
  if (import.meta.env.MODE === 'test') return 'production';
  return import.meta.env.DEV ? 'dev' : 'production';
}

/** `DEV` / `STAGE` — the ribbon's word and a share's mark; null on production. */
export function environmentMark(env: DeployEnv = deployEnv()): 'DEV' | 'STAGE' | null {
  return env === 'staging' ? 'STAGE' : env === 'dev' ? 'DEV' : null;
}

/**
 * A message shared from dev or staging, said to be a test first (the sentence comes from the caller's
 * `tr`, so it is in the reader's language); on production the message as it is.
 */
export function sharedFromHere(text: string, testWords: string, env: DeployEnv = deployEnv()): string {
  return environmentMark(env) ? `${testWords} ${text}` : text;
}
